enum KBVisibility {
    Internal = 1,
	External = 2
}

export default KBVisibility;
